import React, { useEffect } from "react"
import { Box, styled } from "@mui/material"

import { useAppDispatch, useAppSelector } from "redux/hooks"
import { fetchPaymentScheduleDates } from "redux/features/payment_schedule_dates/paymentScheduleDatesThunk"
import {
  selectFetchCollectionStatus,
  selectPaymentScheduleDates,
} from "redux/features/payment_schedule_dates/paymentScheduleDatesSlice"
import { Progress } from "components/ui/Spinner"
import LoadableCollection from "components/ui/LoadableCollection"
import { PaymentScheduleDate } from "types"

export function withPaymentScheduleDates<GenericType>(
  WrappedComponent: React.ComponentType<GenericType>,
) {
  const WithPaymentScheduleDates = (props: GenericType) => {
    const dispatch = useAppDispatch()

    const dates = useAppSelector((state) =>
      selectPaymentScheduleDates(state),
    ) as PaymentScheduleDate[]
    const fetchStatus = useAppSelector((state) =>
      selectFetchCollectionStatus(state),
    )

    const handleFetchDates = () => {
      if (!fetchStatus.isFetching) {
        dispatch(fetchPaymentScheduleDates())
      }
    }

    useEffect(() => handleFetchDates(), [])

    const renderLoader = () => {
      return (
        <Container>
          <Progress color="primary" />
        </Container>
      )
    }

    return (
      <LoadableCollection
        fetchStatus={fetchStatus}
        renderLoading={renderLoader}
      >
        {() => (
          <WrappedComponent
            {...props}
            dates={dates}
            fetchStatus={fetchStatus}
            fetchDates={handleFetchDates}
          />
        )}
      </LoadableCollection>
    )
  }

  return WithPaymentScheduleDates
}

const Container = styled(Box)`
  display: flex;
  align-self: center;
  justify-content: center;
  position: absolute;
  top: calc(50% - 22.5px);
`
